module.exports = __webpack_public_path__ + "img/47cae16.svg";